import { ChangeDetectionStrategy, Component, ElementRef, input, output } from '@angular/core';
import { SearchRequestModel } from 'src/business/openapi';
import { CommonModule } from 'src/common/common.module';

@Component({
  selector: 'app-product-search-bar',
  imports: [CommonModule],
  templateUrl: './product-search-bar.component.html',
  styleUrl: './product-search-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSearchBarComponent {
  request = output<SearchRequestModel | undefined>();
  submit = output<SearchRequestModel | undefined>();
  formName = input<string | null>(null);
  initialValue = input<string | null | undefined>(null);
  constructor(public elm: ElementRef<HTMLElement>) {

  }
  onSubmit(form: HTMLFormElement) {
    queueMicrotask(() => {
      let req = Object.fromEntries(new FormData(form)) as SearchRequestModel;
      this.submit.emit(req);
    })
    return false;
  }
  reset() {
    let elm = this.elm.nativeElement.querySelector('[name=searchTerms]') as HTMLInputElement;
    if (elm != null) elm.value = '';
  }
  onChange(event: Event) {
    let form = (event.target as HTMLInputElement).form;
    if (!form)
      return
    queueMicrotask(async () => {
      let req = Object.fromEntries(new FormData(form)) as SearchRequestModel;
      this.request.emit(req);
    })
  }
}
